<template>
  <div class="container">
    <div id="head">
      <HeaderBtnList :isAdmin="isAdmin === 1" @myClick="handlerMenuClick" />
    </div>
    <!-- 工作日 -->
    <template v-if="!show.isRest">
      <div id="theme">
        <ClockInTheme
          :date="unlockTime"
          :title="title"
          :content="content"
          :isOpen.sync="show.isOpenTheme"
          v-if="content"
        />
      </div>

      <!-- 我的打卡 -->
      <div id="mycard">
        <MyClockInCard
          :detailId="detailId"
          :date="unlockTime"
          v-if="isClockIn && unlockTime"
        />
      </div>

      <!-- 人数/分组/筛选 -->
      <div class="people-num">
        <div>{{ isAdmin ? "已提交" : "今日打卡" }}：{{ clockInNum }}人</div>
        <div class="group" @click="handlerGroupToggle" v-if="groups.length">
          <span :style="groupName ? 'color: #ff9645;' : ''">{{
            groupName || "分组"
          }}</span>
          <img
            src="@/assets/clock/icon_dropdown_gray.png"
            alt="menu"
            class="group-icon"
            :class="{ 'active-group-icon': groupMenuState }"
            v-if="!groupName"
          />
          <img
            src="@/assets/clock/com_icon_dropdown_orange.png"
            alt="menu"
            class="group-icon"
            :class="{ 'active-group-icon': groupMenuState }"
            v-if="groupName"
          />

          <div class="group-menu">
            <van-dropdown-menu
              :direction="direction"
              :close-on-click-overlay="false"
            >
              <van-dropdown-item
                title="分组"
                ref="group"
                @open="handlerOpenMenu"
                @close="handlerCloseMenu"
              >
                <div
                  class="group-item"
                  @click="handlerCheckGroup(-1, '全部分组')"
                >
                  <span class="group-text" :class="{ active: groupId === -1 }"
                    >全部分组</span
                  >
                  <img
                    src="@/assets/clock/com_icon_choice1.png"
                    alt="select"
                    class="group-icon"
                    v-if="groupId === -1"
                  />
                </div>
                <div
                  class="group-item"
                  v-for="item in groups"
                  :key="item.id"
                  @click="handlerCheckGroup(item.id, item.name)"
                >
                  <span
                    class="group-text"
                    :class="{ active: groupId === item.id }"
                    >{{ item.name }}</span
                  >
                  <img
                    src="@/assets/clock/com_icon_choice1.png"
                    alt="select"
                    class="group-icon"
                    v-if="groupId === item.id"
                  />
                </div>
              </van-dropdown-item>
            </van-dropdown-menu>
          </div>
        </div>
        <div class="admin-switch" v-if="isAdmin">
          <span class="tool-text">筛选未点评</span>
          <van-switch
            v-model="showNoComment"
            :active-value="1"
            :inactive-value="0"
            size="22px"
            active-color="#FF9645"
            inactive-color="#E9E9EB"
          />
        </div>
      </div>

      <!-- 打卡列表 -->
      <ClockInList
        :detailId="detailId"
        :showNoComment="showNoComment"
        :isAdmin="isAdmin === 1"
        :classId="classId"
        :groupId="groupId"
        v-if="isClockIn || !isPreventCheat || isAdmin"
      />
      <!-- 未打卡且后台开启了防作弊，显示的内容 -->
      <div class="not-data" v-if="isPreventCheat && !isClockIn && !isAdmin">
        <img src="@/assets/not-data.png" alt="not-data" class="not-data-img" />
        <p class="tip-text">打卡后可查看全部学员打卡内容</p>
      </div>
      <!-- 未打卡，后台也没有开启防作弊且没有人打卡了 -->
      <div
        class="not-data"
        v-if="!isPreventCheat && !clockInNum && !isClockIn && !isAdmin"
      >
        <img
          src="@/assets/my-clock-in-empty.png"
          alt="not-data"
          class="not-data-img"
        />
        <p class="tip-text">快来抢下第一条打卡～</p>
      </div>
      <!-- 班委端没有人打卡内容 -->
      <div class="not-data" v-if="!clockInNum && isAdmin">
        <img
          src="@/assets/my-clock-in-empty.png"
          alt="not-data"
          class="not-data-img"
        />
        <p class="tip-text">暂时没有学员打卡</p>
      </div>
      <img
        src="@/assets/youjiang.png"
        alt="logo"
        class="logo"
        v-if="!show.isRest"
      />
      <!-- 未打卡且不是班委端跳转过来的才显示 -->
      <div class="btm-btn" v-if="!isClockIn && isAdmin !== 1">
        <button class="clock-in-btn" @click="handlerClockIn">我要打卡</button>
      </div>
    </template>
    <!-- 休息日 -->
    <div class="rest" v-if="show.isRest">
      <p class="rest-date">{{ show.nowDate }}</p>
      <div class="rest-focus">
        <img src="@/assets/clock-in-rest.png" alt="rest" class="rest-img" />
        <p class="rest-text">今日休息，劳逸结合也很重要哦～</p>
      </div>
      <img src="@/assets/youjiang.png" alt="" class="rest-logo" />
    </div>

    <!-- 日历 -->
    <Popup
      v-model="menuState.calendar"
      :close-on-click-overlay="false"
      round
      closeable
      safe-area-inset-bottom
      position="bottom"
    >
      <h4 class="dialog-title">切换日期</h4>
      <div class="dialog-content" v-if="clockInPlanData.planList.length > 0">
        <ClockInCalendar
          :clockInRange="clockInPlanData.clockInRange"
          :clockInDate="clockInPlanData.clockInDates"
          :againClockIn="clockInPlanData.cardReissueDates"
          :restDates="clockInPlanData.restDates"
          @myClick="handlerCalendarClick"
          v-if="isAdmin !== 1"
        />
        <ClockInCalendar
          :clockInRange="clockInPlanData.clockInRange"
          :clockInDate="clockInPlanData.clockInDates"
          :restDates="clockInPlanData.restDates"
          :isHighLight="false"
          @myClick="handlerCalendarClick"
          v-if="isAdmin === 1"
        />
      </div>
      <div class="dialog-footer">
        <div class="dialog-tip-text">
          <template v-if="!isAdmin">
            补打卡剩余<span class="clock-in-count">{{
              clockInPlanData.cardReissueCount
            }}</span
            >次
          </template>
        </div>
        <div class="dialog-tip-icon">
          <i class="icon gray"></i>
          <span>{{ isAdmin ? "未解锁" : "未打卡" }}</span>
          <i :class="isAdmin ? 'gray' : 'orange'" class="icon"></i>
          <span>{{ isAdmin ? "已解锁" : "已打卡" }}</span>
        </div>
      </div>
    </Popup>

    <ClockInPoster
      :show.sync="menuState.poster"
      :id="detailId"
      v-if="isClockIn"
    />

    <GroupSheet
      :show.sync="showGroupSheet"
      :groups="groups"
      :idObj="{ detailId, classId }"
      @success="handlerGroupSuccess"
      v-if="group_id === 0 && isAdmin === 0"
    />

    <van-dialog
      v-model="isShowClass"
      width="295"
      :showConfirmButton="false"
      v-if="!class_id"
    >
      <img
        src="@/common/images/com_icon_close_gray@2x.png"
        alt="close"
        class="close-btn"
        @click="isShowClass = false"
      />
      <div class="class-title">未加入班级</div>
      <div class="class-tip-text">请先联系班委或客服加入班级</div>
      <img :src="serviceQrCode" alt="qrcode" class="class-qrcode" />
      <div class="qrcode-des">客服二维码</div>
      <div class="classbtn" @click="isShowClass = false">我知道了</div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Popup, Toast, Dialog, Switch, DropdownMenu, DropdownItem
} from 'vant';
import HeaderBtnList from '@/components/clockInHeadBtnList/index.vue';
import ClockInTheme from '@/components/clockInTheme/index.vue';
import ClockInCalendar from '@/components/clockInCalendar/index.vue';
import ClockInPoster from '@/components/clockInPoster/index.vue';
import {
  formatDate,
  clipboard,
  isWechat,
  getCurrdateStr,
} from '@/common/js/utils';
import Cookies from 'js-cookie';
import WxShare from '@/common/js/wxShare';
import { clockInThemeApi, calendarApi, getClassGroup } from '@/api/clockin';
import { getCampSeriesSummary, getUserViewData } from '@/api/api';
import {
  ref,
  toRefs,
  reactive,
  onMounted,
  onUnmounted,
  nextTick,
  onActivated,
  onDeactivated,
} from '@vue/composition-api';
import router from '@/router';
import request from '@/plugins/axios';
import store from '@/store/index';
import MyClockInCard from './components/MyClockInCard.vue';
import ClockInList from './components/ClockInList.vue';
import GroupSheet from './components/GroupSheet.vue';

export default {
  components: {
    HeaderBtnList,
    ClockInTheme,
    Popup,
    ClockInCalendar,
    ClockInPoster,
    MyClockInCard,
    ClockInList,
    [Switch.name]: Switch,
    GroupSheet,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const { themeData, getThemeData } = useThemeData();
    const { clockInPlanData, getClockPlan } = usePlanData();

    const detailId = ref(0);

    /**
     * @description 是否是班委，从班级详情页进入
     */
    const isAdmin = ref(0);
    const classId = ref(0);

    const show = ref({
      isRest: true, // 是否休息日
      isOpenTheme: false, // 是否展开主题
      nowDate: '', // 休息日显示的日期
    });

    /**
     * @description 是否打卡了
     */
    const isClockIn = ref(false);

    /**
     * @description 菜单状态
     */
    const menuState = ref({
      poster: false, // 是否 显示海报
      calendar: false, // 是否 显示日历
    });

    /**
     * @description 分组列表
     */
    const groups = ref([]);

    /**
     * @description 顶部菜单栏点击事件
     */
    const handlerMenuClick = (type) => {
      if (type === 2) {
        // 用户点击切换日期时，显示打卡日历
        menuState.value.calendar = true;
        return;
      }

      if (isAdmin.value === 1) {
        const url = window.location.href.split('?')[0];

        clipboard(`${url}?id=${detailId.value}`);
        Toast('链接已复制');
      } else if (isClockIn.value) {
        // 显示日签
        menuState.value.poster = true;
      } else {
        if (show.value.isRest) {
          Toast('今日休息');
          return;
        }

        Toast('请先完成作业');
      }
    };

    /**
     * @description 0 显示所有人的打卡列表，1 只显示未点评的
     */
    const showNoComment = ref(0);

    /**
     * @description 点击日历事件
     */
    const handlerCalendarClick = async (date) => {
      menuState.value.calendar = false;

      if (date === themeData.unlockTime) {
        return;
      }

      const index = clockInPlanData.value.planList.findIndex(
        item => item.date_str === date
      );

      if (index === -1) {
        return;
      }

      const value = clockInPlanData.value.planList[index];
      detailId.value = value.detail_id;
      sessionStorage.detailId = JSON.stringify(value.detail_id);

      // 休息日
      if (value.detail_id === 0) {
        isClockIn.value = false;
        show.value.isRest = true;

        sessionStorage.courseId = JSON.stringify(themeData.courseId);
      }

      const searchObj = new URLSearchParams(window.location.search);
      searchObj.set('id', detailId.value);

      if (value.detail_id === 0) {
        const t = new Date(date);
        searchObj.set('t', t.getTime());
      }

      setTimeout(() => {
        router.push(`clock-in-theme?${searchObj.toString()}`);
        init();
      }, 300);
    };

    /**
     * @description 用户未参加分组时，是否显示选择分组弹窗
     */
    const showGroupSheet = ref(false);

    /**
     * @description 打卡事件
     */
    const handlerClockIn = () => {
      // 没有加入班级群
      if (!themeData.class_id) {
        themeData.isShowClass = true;
        return;
      }

      // 班级分组了但学员没有加入分组
      if (groups.value.length && !themeData.group_id) {
        showGroupSheet.value = true;
        return;
      }

      // 当天打卡
      if (
        themeData.unlockTime === getCurrdateStr('/', store.state.currentDateObj)
      ) {
        router.push(
          `/clock-in/${detailId.value}/${themeData.unlockTime.replace(
            /\//g,
            '-'
          )}/0`
        );
        return;
      }

      // 补卡
      if (clockInPlanData.value.cardReissueCount) {
        router.push(
          `/clock-in/${detailId.value}/${themeData.unlockTime.replace(
            /\//g,
            '-'
          )}/0`
        );
        return;
      }

      Toast('您的补卡次数已用尽');
    };

    /**
     * @description 加入分组成功，跳转到打卡页
     */
    const handlerGroupSuccess = (id) => {
      themeData.group_id = id;

      handlerClockIn();
    };

    const {
      group,
      groupId,
      groupName,
      direction,
      handlerGroupToggle,
      handlerCheckGroup,
      handlerOpenMenu,
      handlerCloseMenu,
      groupMenuState,
    } = useGroup();

    const init = async () => {
      // 如果没有传打卡小节ID，则直接返回
      if (router.currentRoute.query.id) {
        detailId.value = +router.currentRoute.query.id;
      } else {
        return;
      }

      // 班委从班级详情页进来则为1
      isAdmin.value = 0;
      if (router.currentRoute.query.admin) {
        isAdmin.value = +router.currentRoute.query.admin;
      }

      // 班委从班级详情页进来，则要带上对应的班级ID
      classId.value = 0;
      if (router.currentRoute.query.classId) {
        classId.value = +router.currentRoute.query.classId;
      }

      // 从打卡页打卡成功跳转回来，显示海报（编辑不显示）
      if (router.currentRoute.params.edit === 0) {
        menuState.value.poster = true;
      }

      // 数据初始化
      show.value.isRest = true;
      show.value.isOpenTheme = false;
      show.value.nowDate = '';
      isClockIn.value = false;
      showNoComment.value = 0;
      groupId.value = -1;
      groupName.value = '';

      // 学习小节id不为0，则请求主题数据
      if (detailId.value !== 0) {
        const paramObj = {
          detail_id: detailId.value,
        };

        // 班委是从班级详情页进入，则带上班级ID
        if (isAdmin.value) {
          paramObj.class_id = classId.value;
        }

        getClassGroup(paramObj).then((res) => {
          if (res.items.length) {
            const list = res.items.map(item => ({
              id: item.id,
              name: item.name,
            }));

            groups.value = list;
          }
        });

        await getThemeData(paramObj);
      }

      // 学习小节id为0: 休息日，则从sesstionStorage中取出课程ID
      if (detailId.value === 0 && sessionStorage.courseId) {
        const restObj = JSON.parse(sessionStorage.courseId);
        const { t } = router.currentRoute.query;

        themeData.unlockTime = +t;
        themeData.courseId = restObj;
      }

      // 不是班委，则判断是否购买了课程
      if (!isAdmin.value) {
        const isBuy = await isBuyCourse(themeData.courseId);

        if (!isBuy) {
          return;
        }
      }

      setWxShare(themeData.unlockTime, themeData.courseId, detailId.value);
      await getClockPlan(themeData.courseId);

      if (detailId.value === 0) {
        show.value.isRest = true;
      } else {
        show.value.isRest = false;
      }

      if (show.value.isRest) {
        show.value.nowDate = formatDate(themeData.unlockTime);
        return;
      }

      const isUserClockIn = getIsClockIn(
        clockInPlanData.value.planList,
        themeData.unlockTime
      );

      if (isAdmin.value !== 1 && isUserClockIn) {
        // 不是班委且打卡了
        isClockIn.value = true;
        show.value.isOpenTheme = false;
      } else if (isAdmin.value !== 1 && !isUserClockIn) {
        // 不是班委且未打卡
        isClockIn.value = false;
        show.value.isOpenTheme = true;
      } else {
        // 班委
        isClockIn.value = false;
        show.value.isOpenTheme = false;
      }
    };

    onMounted(async () => {
      const userId = Cookies.get('user_id');
      if (!isWechat() && !userId) {
        // 不是用微信打开且用户未登录则跳转到登录页
        router.replace({
          path: '/login',
          query: {
            redirect: `/clock-in-theme?id=${router.currentRoute.query.id}`,
          },
        });
        return;
      }

      if (!userId) {
        // 等待自动登录的结果
        await verifyWxLogin();
      }

      init();
    });

    onUnmounted(() => {
      // 页面销毁的时候重置分享内容
      WxShare();
    });

    useUpdate(init, menuState, group, groupMenuState);

    return {
      show,
      detailId,
      ...toRefs(themeData),
      clockInPlanData,
      menuState,
      isClockIn,
      isAdmin,
      classId,
      showNoComment,
      handlerMenuClick,
      handlerCalendarClick,
      handlerClockIn,
      showGroupSheet,
      handlerGroupSuccess,
      group,
      handlerGroupToggle,
      groupId,
      groups,
      handlerCheckGroup,
      groupName,
      direction,
      handlerOpenMenu,
      handlerCloseMenu,
      groupMenuState,
    };
  },
};

/**
 * @description 设置打卡主题相关数据
 */
function useThemeData() {
  const themeData = reactive({
    unlockTime: '', // 主题解锁时间
    title: '', // 主题标题
    clockInNum: 0, // 当日打卡数量
    content: '', // 主题内容
    courseId: '', // 课程ID
    isPreventCheat: true, // 是否防作弊
    group_id: 0, // 分组ID，0 代表没有分组
    class_id: 0, // 0代表学员没有加入班级
    isShowClass: false, // 是否显示加入班级弹窗
    serviceQrCode: '', // 加入班级客服二维码
  });

  /**
   * @description 获取打卡主题数据
   * @param {object} args
   * @param {number} args.detail_id 学习小节的id
   * @param {number} [args.class_id] 班级ID
   * @returns {promise}
   */
  const getThemeData = args => new Promise((resolve) => {
    clockInThemeApi(args).then(async (res) => {
      const { data } = res;
      themeData.group_id = data.group_id;
      themeData.class_id = data.class_id;

      themeData.unlockTime = data.content_data.unlock_time
        .substr(0, 10)
        .replace(/-/g, '/');

      // eslint-disable-next-line camelcase
      const { punch_data } = data;
      themeData.title = punch_data.title;
      themeData.clockInNum = punch_data.punch_count;

      // eslint-disable-next-line camelcase
      const { series_data } = data;
      themeData.courseId = series_data.id;
      // 保存课程ID，打卡页需要使用
      sessionStorage.courseId = JSON.stringify(themeData.courseId);

      document.title = series_data.name;
      themeData.isPreventCheat = !!series_data.prevent_cheat;
      themeData.serviceQrCode = series_data.after_sale_image;

      // 获取富文本内容
      const url = punch_data.content;
      themeData.content = await request({
        method: 'get',
        url,
        withCredentials: false,
      });

      themeData.isShowClass = false;

      resolve();
    });
  });

  return {
    themeData,
    getThemeData,
  };
}

/**
 * @description 设置打卡计划相关数据
 */
function usePlanData() {
  const clockInPlanData = ref({
    cardReissueCount: 0, // 剩余补卡次数
    planList: [], // 打卡计划表
    clockInRange: {
      // 打卡范围
      begDate: '',
      endDate: '',
    },
    clockInDates: [], // 已打卡日期表
    cardReissueDates: [], // 补卡日期表
    restDates: [], // 休息日
  });

  /**
   * @description 获取打卡计划相关数据
   * @param {number} courseId 课程ID
   * @returns {promise}
   */
  const getClockPlan = courseId => new Promise((resolve) => {
    calendarApi(courseId).then((res) => {
      const { data } = res;
      const backVal = {
        cardReissueCount: 0,
        planList: [],
        clockInRange: null,
        clockInDates: [],
        cardReissueDates: [],
        restDates: [],
      };

      // 剩余补卡次数
      backVal.cardReissueCount = data.fill_left_count;

      // 打卡日期表
      const planList = data.plan_list.map(item => ({
        ...item,
        date_str: item.date_str.replace(/-/g, '/'),
      }));
      backVal.planList = planList;

      // 设置打卡范围
      backVal.clockInRange = {
        begDate: planList[0].date_str,
        endDate: planList[planList.length - 1].date_str,
      };

      // 筛选出已打卡的日期
      const clockInDates = planList.filter(item => item.punch_status === 1);
      if (clockInDates.length > 0) {
        backVal.clockInDates = clockInDates.map(item => item.date_str);
      }

      // 筛选出补卡的日期
      const cardReissueDates = planList.filter(
        item => item.punch_status === 2
      );
      if (cardReissueDates.length > 0) {
        backVal.cardReissueDates = cardReissueDates.map(
          item => item.date_str
        );
      }

      // 筛选出休息日
      const restDates = planList.filter(item => item.detail_id === 0);
      if (restDates.length) {
        backVal.restDates = restDates.map(item => item.date_str);
      }

      clockInPlanData.value = backVal;
      resolve();
    });
  });

  return {
    clockInPlanData,
    getClockPlan,
  };
}

/**
 * @description 验证微信自动登录是否已登录，失败跳转到登录页
 */
async function verifyWxLogin() {
  let checkCount = 20;

  /**
   * @description 每一百毫秒检测一次微信自动登录是否已登录成功，最多二十次
   * @returns {promise} 成功resolve(true)，失败resolve(false)
   */
  const isAutoLoginSuccess = () => new Promise((resolve) => {
    setTimeout(() => {
      const userId = Cookies.get('user_id');

      if (userId) {
        resolve(true);
      } else if (checkCount) {
        checkCount -= 1;
        isAutoLoginSuccess();
      } else {
        resolve(false);
      }
    }, 100);
  });

  const next = await isAutoLoginSuccess();

  // 自动登录失败
  if (!next) {
    // eslint-disable-next-line no-restricted-globals
    const url = location.href.replace(location.origin, '');

    router.replace({
      path: '/login',
      query: { redirect: url },
    });
  }
}

/**
 * @description 用户是否购买了课程，没有跳转到购买页
 * @param {number} courseId 课程ID
 * @returns {promise} 买了resolve(true)，反之resolve(false)
 */
function isBuyCourse(courseId) {
  return new Promise((resolve) => {
    getUserViewData(courseId).then((res) => {
      const isBuy = res.data.is_paid;

      if (!isBuy) {
        Dialog.confirm({
          title: '请先购买课程',
          showCancelButton: false,
        })
          .then(() => {
            window.location.href = `${window.location.origin}/classroom/camp/${courseId}`;
          })
          .catch(() => {});
        resolve(false);
      }

      resolve(true);
    });
  });
}

/**
 * @description 判断用户这天是否打卡了
 * @param {object[]} list 打卡计划表
 * @param {string} date 日期字符串
 * @returns {Boolean} 打卡了返回true，反之false
 */
function getIsClockIn(list, date) {
  const idx = list.findIndex(item => item.date_str === date);

  if (idx === -1) {
    return false;
  }

  if (list[idx].punch_status === 1 || list[idx].punch_status === 2) {
    return true;
  }

  return false;
}

/**
 * @description 设置微信分享内容
 * @param {string} date 日期字符串
 * @param {number} courseId 课程ID
 * @param {number} id 学习小节ID
 */
async function setWxShare(date, courseId, id) {
  const newDate = formatDate(date);

  const link = `${window.location.href.split('?')[0]}?id=${id}`;

  const share = {
    title: document.title,
    desc: `${newDate}打卡`,
    link,
    imgUrl: '',
  };

  const img = await getCampSeriesSummary(courseId);

  if (img) {
    share.imgUrl = img.teacher_image;
  }

  WxShare(share);
}

/**
 * @description 筛选分组相关操作
 */
function useGroup() {
  /**
   * @description 分组的菜单dom对象
   */
  const group = ref(null);

  const list = ['down', 'up'];
  /**
   * @description 分组筛选菜单展开方向
   */
  const direction = ref(list[0]);

  let headMenuHeight = 0;
  let myCardHeight = 0;

  let clientHeight = 0;

  const isAdmin = +router.currentRoute.query.admin;

  /**
   * @description 点击分组，打开/关闭分组
   */
  const handlerGroupToggle = () => {
    if (!clientHeight) {
      clientHeight = Math.min(
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
    }

    if (!headMenuHeight) {
      headMenuHeight = document.getElementById('head').scrollHeight;
    }

    // 从打卡页返回这个页面，则重新获取高度
    if (router.currentRoute.params.edit !== undefined) {
      myCardHeight = document.getElementById('mycard').scrollHeight;
    }

    // 班委没有我的打卡卡片
    if (!myCardHeight && !isAdmin) {
      myCardHeight = document.getElementById('mycard').scrollHeight;
    }

    const themeHeight = document.getElementById('theme').scrollHeight;

    let scrollTop = 0;

    if (document.documentElement && document.documentElement.scrollTop) {
      // eslint-disable-next-line prefer-destructuring
      scrollTop = document.documentElement.scrollTop;
    } else {
      // eslint-disable-next-line prefer-destructuring
      scrollTop = document.body.scrollTop;
    }

    const distanceTopHeight = clientHeight + scrollTop - (headMenuHeight + myCardHeight + themeHeight);
    if (distanceTopHeight < 260) {
      // eslint-disable-next-line prefer-destructuring
      direction.value = list[1];
    } else {
      // eslint-disable-next-line prefer-destructuring
      direction.value = list[0];
    }

    nextTick(() => {
      group.value.toggle();
    });
  };

  const groupId = ref(-1);
  const groupName = ref('');

  /**
   * @description 切换分组事件
   * @param {number} id 分组ID
   * @param {string} name 分组名称
   */
  const handlerCheckGroup = (id, name) => {
    setTimeout(() => {
      groupId.value = id;
      groupName.value = name;
    }, 200);
  };

  const groupMenuState = ref(false);
  const handlerOpenMenu = () => {
    groupMenuState.value = true;
  };

  const handlerCloseMenu = () => {
    groupMenuState.value = false;
  };

  return {
    group,
    groupId,
    groupName,
    direction,
    handlerGroupToggle,
    handlerCheckGroup,
    handlerOpenMenu,
    handlerCloseMenu,
    groupMenuState,
  };
}

/**
 * @description 当本页面的url改变时更新数据
 * @param {function} fn 更新数据方法
 * @param {object} menuState 弹窗状态
 * @param {object} group 分组菜单dom
 */
function useUpdate(fn, menuState, group, groupMenuState) {
  if (typeof fn !== 'function') {
    return;
  }

  /**
   * @description 处理本页面的回退事件
   */
  function backPage() {
    store.commit('SET_THEME_URL', window.location.href);
    menuState.value.poster = false;
    menuState.value.calendar = false;

    if (group.value) {
      group.value.toggle(false);
    }

    groupMenuState.value = false;

    fn();
  }

  onActivated(() => {
    // 监听页面回退事件，解决本页面回退后url改变但是数据不变的问题。
    // 例如：进入页面时是22号的数据，然后点击日历跳转到23号的数据，最后再回退页面。
    window.addEventListener('popstate', backPage, false);

    // 关闭日签和海报
    menuState.value.poster = false;
    menuState.value.calendar = false;

    nextTick(() => {
      if (group.value) {
        group.value.toggle(false);
        groupMenuState.value = false;
      }
    });

    // 从其他页面返回本页面时，url和离开的url时不一致，则更新页面
    const oldUrl = store.state.themeUrl;
    const newUrl = window.location.href;

    store.commit('SET_THEME_URL', newUrl);

    // 第一次进入页面
    if (!oldUrl) {
      return;
    }

    if (oldUrl !== newUrl) {
      // 更新页面
      fn();
    }
  });

  onDeactivated(() => {
    // 离开本页面时，移除页面回退事件的监听
    window.removeEventListener('popstate', backPage);
  });
}
</script>

<style lang="stylus" scoped>
.container {
  position: relative;
}

.people-num {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 12px;
  font-size: 12px;
  color: #999;
}

.not-data {
  margin: 0 12px;
  width: calc(100% - 24px);
  background: #fff;

  .not-data-img {
    display: block;
    margin: 16px auto;
    width: 68%;
  }

  .tip-text {
    padding-bottom: 29px;
    font-size: 14px;
    color: #999;
    text-align: center;
  }
}

.logo {
  display: block;
  margin: 0 auto;
  margin-top: 28px;
  margin-bottom: 56px;
  width: 64px;
}

.btm-btn {
  position: fixed;
  bottom: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 750px;
  height: 49px;
  background: #FFFFFF;
}

.clock-in-btn {
  width: calc(100% - 32px);
  height: 40px;
  background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
  border-radius: 6px;
  outline: none;
  border: none;
  font-size: 16px;
  color: #fff;
}

.rest {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 64px);
  background: #fff;

  .rest-date {
    position: absolute;
    top: 20px;
    left: 16px;
    font-size: 14px;
    color: #999;
  }

  .rest-focus {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .rest-img {
    display: block;
    width: 68%;
  }

  .rest-text {
    margin-top: 13px;
    font-size: 14px;
    color: #999;
  }

  .rest-logo {
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -32px;
    width: 64px;
  }
}

.dialog-title {
  margin: 18px auto;
  font-size: 16px;
  font-weight: 500;
  color: #191919;
  text-align: center;
}

.dialog-content {
  margin: 0 16px 30px 16px;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 6px;
  left: 16px;
  margin-right: 16px;
  width: calc(100% - 32px);
  font-size: 12px;
  color: #999;

  .clock-in-count {
    margin: 0 5px;
    color: #FF9645;
  }

  .dialog-tip-icon {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .icon {
    display: inline-block;
    margin: 0 4px 0 10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  .gray {
    background: #E7E7E7;
  }

  .orange {
    background: #FF9645;
  }
}

.admin-switch {
  display: flex;
  align-items: center;
}

.tool-text {
  margin-right: 9px;
  font-size: 12px;
  color: #999;
}

/deep/ .van-overlay {
  background: rgba(0, 0, 0, 0.4);
}

.group {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-icon {
  width: 12px;
  height: 12px;
  transition: all 0.2s;
}

.active-group-icon {
  transform: rotate(180deg);
}

.group-menu {
  position: absolute;

  // right 0
  // top 0
  .group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 16px;
    height: 46px;
    box-sizing: border-box;
    border-bottom: 0.5px solid #e7e7e7;

    .group-icon {
      width: 16px;
      height: 16px;
    }

    .group-text {
      margin-right: 32px;
      width: 100%;
      font-size: 14px;
      color: #191919;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .active {
      color: #ff9645;
    }
  }
}

/deep/ .van-dropdown-menu__bar {
  height: 44px;
  box-shadow: none;
  visibility: hidden;
}

.group-title {
  max-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.class-title {
  margin-top: 24px;
  margin-bottom: 12px;
  height: 24px;
  font-size: 18px;
  font-weight: 500;
  color: #191919;
  line-height: 24px;
  text-align: center;
}

.class-tip-text {
  margin-bottom: 20px;
  height: 20px;
  font-size: 15px;
  color: #999;
  line-height: 20px;
  text-align: center;
}

.class-qrcode {
  display: block;
  margin: 0 auto;
  width: 140px;
  height: 140px;
}

.qrcode-des {
  margin-top: 6px;
  font-size: 14px;
  color: #999;
  text-align: center;
}

.classbtn {
  margin: 16px auto;
  margin-bottom: 24px;
  width: 247px;
  height: 40px;
  border-radius: 22px;
  background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
}

/deep/ .van-dialog {
  border-radius: 8px;
}
</style>
